import { RouteType } from "types/RouteType";
import DevOpsOverviewStore from "./DevOpsOverviewStore";
import { devopsLinkDialog } from "../shared/devopsLinkDialog";

/**
 * The DevOps landing page — projects by client, from ONE local rollup.
 * `/devops` sits above the boards (`/devops/pipelines`, …) and Project 360
 * (`/devops/projects/:connectionId/:projectId`).
 */
const devopsOverviewRoute: RouteType[] = [
  {
    name: "DevOpsOverview",
    path: "/devops",
    layout: "/app",
    viewportCard: {
      header: {
        title: "DevOps",
        enableRefreshButton: true,
        component: () => import("./DevOpsOverview.Header"),
      },
      body: {
        component: () => import("./DevOpsOverview.Body"),
        grayBackground: true,
      },
    },
    group: "DevOps",
    searchAliases: ["devops", "azure devops", "projects", "clients devops"],
    // Reads are viewer+ (the API's staff-read gate on `devops-overview`); the
    // one write here, "Link a project", is operator+ and hidden otherwise.
    requiresAuth: true,
    requiresPermission: false,
    // Subscribe to the live `devops-event` bus and load the rollup. The
    // header's refresh button re-runs this; both are idempotent.
    onEnter: ({ rootStore }) => {
      const store = rootStore.devopsOverviewViewStore as DevOpsOverviewStore | undefined;
      void store?.initialize();
    },
    // Tear down the live subscription (and a pending debounced refresh) so it
    // cannot leak across navigation — the socket is refcounted/shared.
    onExit: ({ rootStore }) => {
      const store = rootStore.devopsOverviewViewStore as DevOpsOverviewStore | undefined;
      store?.dispose();
    },
    dialogs: [devopsLinkDialog],
  },
];

export default devopsOverviewRoute;
